<script>
    import {createEventDispatcher} from "svelte";
    import {t} from "../core/i18n/language-store.js";
    const dispatch = createEventDispatcher();

    export let prices = [];
    export let currency = undefined;

    function selectHandler(priceIndex, price) {

        prices.forEach(x => {
            x.selected = x === price;
        });

        prices = [...prices];

        dispatch('changed', {prices});
    }

</script>

<style>
    .pb-05 {
        padding-bottom: .5rem;
    }
    strong {
        font-weight: 400;
        font-family: Roboto Condensed, sans-serif;
        text-transform: uppercase;
    }

    ul li {
        font-weight: 300;
        font-family: Roboto Condensed, sans-serif;
        padding: .4rem 0;
        color: var(--main-font-color);
        transition: color .2s ease;
    }
    ul li.option--selected {
        color: var(--accent-color);
    }

    svg.selected {
        display: none;
    }
    svg.unselected {
        display: inline-block;
    }

    .option--selected {

    }
    .option--selected svg.selected {
        display: inline-block;
    }
    .option--selected svg.unselected {
        display: none;
    }
    .price {
        font-family: PT Mono, sans-serif;
    }
</style>

<div class="variant-selector-title pb-05">
    <strong>{$t('variantSelector.chooseOption')}</strong>
</div>

<ul>
    {#each prices as price, index}

    <li class="variant flex-between" class:option--selected={price.selected} on:click={() => selectHandler(index, price)}>
        <div class="flex ai-center gap-05 lh-1">

            <svg class="selected" width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="5.5" fill="currentColor" stroke="currentColor"/>
                <path d="M3 5L5.5 8.5L9.5 3.5" stroke="black" stroke-linejoin="round"/>
            </svg>

            <svg class="unselected" width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
            </svg>

            <span class="weight">
                { price.weight || '' }
            </span>
        </div>
        <div>
            <span class="old-price fs-90" style="text-decoration: line-through">{ price.oldPrice || ''}</span>
            <span class="price">{ price.price || '0' } { currency || '' }</span>
        </div>
    </li>
    {/each}
</ul>
